import styled from 'styled-components';

export const ErrorMessage = styled.div`
    color: red;
    margin: 5px 0 5px 0;
`;